module.exports = __webpack_public_path__ + "static/media/feel_img_kholvz.6a0a5860.png";